import { cn } from '@web-app/lib/utils';

/** Matches the portal notification dot and destructive badge color. */
export function SupportUnreadIndicator({
  label = 'Unread support messages',
  className,
}: {
  label?: string;
  className?: string;
}) {
  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      className={cn(
        'inline-block size-2.5 shrink-0 rounded-full bg-destructive',
        className,
      )}
    />
  );
}
